export default {
  SET_HEADERS(state, payload) {
    state.headers = [
      {text:"Registro", value: "register"},
      {text:"Animal", value: "animal"},
      ...payload.map(e => ({text: e, value: "date"}))
    ];
  },
  SET_RESULTS(state, payload) {
   state.results = payload;
  },
  SET_RESET_RESULTS(state) {
    state.results = [];
    state.headers = [];
  }
}